import { IconProps } from "../../../types/style";

const WalletChecked = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.02 7.27499C8.81 7.47999 8.69 7.775 8.72 8.09C8.765 8.63 9.26 9.02499 9.8 9.02499H10.75V9.62C10.75 10.655 9.905 11.5 8.87 11.5H3.815C3.97 11.37 4.105 11.21 4.21 11.03C4.395 10.73 4.5 10.375 4.5 10C4.5 8.895 3.605 8 2.5 8C2.03 8 1.595 8.165 1.25 8.44V6.255C1.25 5.22 2.095 4.375 3.13 4.375H8.87C9.905 4.375 10.75 5.22 10.75 6.255V6.97501H9.74C9.46 6.97501 9.205 7.08499 9.02 7.27499Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.25 6.70503V4.42005C1.25 3.82505 1.615 3.29503 2.17 3.08503L6.14 1.58503C6.76 1.35003 7.425 1.81004 7.425 2.47504V4.37504"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.2794 7.48508V8.51511C11.2794 8.79011 11.0594 9.01509 10.7794 9.02509H9.79941C9.25941 9.02509 8.76441 8.63009 8.71941 8.09009C8.68941 7.77509 8.8094 7.48009 9.0194 7.27509C9.2044 7.08509 9.4594 6.9751 9.7394 6.9751H10.7794C11.0594 6.9851 11.2794 7.21008 11.2794 7.48508Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.5 6.5H7"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.5 10C4.5 10.375 4.395 10.73 4.21 11.03C4.105 11.21 3.97 11.37 3.815 11.5C3.465 11.815 3.005 12 2.5 12C1.77 12 1.135 11.61 0.790001 11.03C0.605001 10.73 0.5 10.375 0.5 10C0.5 9.37 0.79 8.805 1.25 8.44C1.595 8.165 2.03 8 2.5 8C3.605 8 4.5 8.895 4.5 10Z"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.7207 9.99976L2.2157 10.4948L3.2807 9.50977"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default WalletChecked;
